module.exports = __webpack_public_path__ + "static/img/nosotros_foto1.ac1083c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/nosotros_foto1.png
// module id = 18
// module chunks = 0